import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=d8f459a0"
import script from "./Autocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./Autocomplete.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f459a0')) {
      api.createRecord('d8f459a0', component.options)
    } else {
      api.reload('d8f459a0', component.options)
    }
    module.hot.accept("./Autocomplete.vue?vue&type=template&id=d8f459a0", function () {
      api.rerender('d8f459a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/forms/Autocomplete.vue"
export default component.exports